/**
 * Featured Reviews Slider Module
 * Handles the initialization and functionality of the featured reviews slider/carousel.
 * Includes color scheme management and responsive breakpoints.
 * @module FeaturedReviews
 */
(function () {
  /**
   * Initializes and configures the reviews slider functionality.
   * Sets up Swiper instance with autoplay, navigation, and color scheme management.
   * @function logoSlideshow
   */
  const logoSlideshow = () => {
    $('.featured-reviews-section').each(function () {
      if ($(this).hasClass('slider_started')) {
        return '';
      }
      $(this).addClass('slider_started');
      const id = $(this).attr('id');
      const box = $(this).find('.featured-reviews');
      const autoplay = box.data('autoplay');
      const stopAutoplay = box.data('stop-autoplay');
      const totalItems = +box.data('items');
      const delay = box.data('delay') * 1000;
      const template = box.data('template');

      let sectionClass = $(this)
        .attr('class')
        .search('shopify-section-group-header-group');

      if (sectionClass > 0 && template == 'no-index') {
        box.remove();
      } else {
        box.addClass('show');
      }

      if (autoplay) {
        autoplayParam = {
          autoplay: {
            delay: delay,
            pauseOnMouseEnter: stopAutoplay,
            disableOnInteraction: false,
          },
        };
      } else {
        autoplayParam = {};
      }

      let swiperParms = {
        parallax: true,
        slidesPerView: 1,
        speed: box.data('speed') * 1000,
        loop: true,
        navigation: {
          nextEl: `#${id} .swiper-button-next`,
          prevEl: `#${id} .swiper-button-prev`,
        },
        pagination: {
          el: `#${id} .swiper-pagination`,
          clickable: true,
        },
        ...autoplayParam,
        breakpoints: {
          768: {
            slidesPerView: 2,
            ...(totalItems > 3 ? autoplayParam : { autoplay: false }),
          },
          1024: {
            slidesPerView: 3,
            ...(totalItems > 3 ? autoplayParam : { autoplay: false }),
          },
        },
      };

      console.log('cdebug', autoplayParam, totalItems, swiperParms);

      const swiper = new Swiper(
        `#${id} .featured-reviews__swiper`,
        swiperParms
      );
      colorScheme(swiper);
      swiper.on('beforeTransitionStart', function () {
        colorScheme(this);
      });
      function colorScheme(context) {
        const activeIndex = context.activeIndex;
        const activeSlide = context.slides[activeIndex];
        const changeItems = [
          context.navigation.nextEl,
          context.navigation.prevEl,
          context.pagination.el,
        ];
        const colorScheme = $(activeSlide)
          .find('.featured-reviews-slide')
          .data('color-scheme');
        changeItems.forEach((item) => {
          $(item)
            .removeClass('color-background-1')
            .removeClass('color-background-4')
            .addClass(colorScheme);
        });
      }
    });
  };

  /**
   * Initializes the reviews slider when the DOM is fully loaded.
   * Also sets up event listener for Shopify section loads.
   */
  document.addEventListener('DOMContentLoaded', function () {
    logoSlideshow();
    document.addEventListener('shopify:section:load', function () {
      logoSlideshow();
    });
  });
})();
